export const statusOptions = [
  { value: "All", label: "All" },
  { value: "completed", label: "Completed" },
  { value: "partially completed", label: "Partially Completed" },
  { value: "in-progress", label: "In Progress" },
  { value: "failed", label: "Failed" },
];

export const typeOptions = [
  { value: "All", label: "All" },
  { value: "Bulk-Register", label: "Student Registration" },
  { value: "Event-Mapping", label: "Student Event Mapping" },
  {
    value: "Offline-Upload",
    label: "Student Offline Response Upload",
  },
];

export const uploadTypeToLabelMap = typeOptions.reduce((acc, option) => {
  if (option.value !== "All") {
    acc[option.value] = option.label;
  }
  return acc;
}, {});
